import { Button, Intent, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingFloat, ILandingSection, ILandingSectionTitle, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import makeupIcon from "../../../../assets/img/makeup.svg"
import titleIcon from "../../../../assets/img/float.svg"
import updateSection from "../utils/updateSection"

/* Protopia Ecosystem component */
export interface IFloatEditFormProps {
   section: ILandingSection
   float: ILandingFloat
}
const FloatEditForm = (props: IFloatEditFormProps): JSX.Element => {
    const onEditTitle = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                ...props.float, 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.FLOAT,
            }            
        })
    }
    const onMakeup = () => {
        useLandingStore.setState({ 
            isMakeupDrawerOpen: true,
            makeupType: SELECT_TYPE.FLOAT
        })
    }
    const onDelete = () => { 
        const newVal: ILandingSection = {
            ...props.section,
            floats: props.section.floats.filter( float => float.id !== props.float.id )
        }
        const step: IHistoryStep = {
            data: newVal,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title: "Delete section float"
        }
        updateSection(newVal, step)
    }

    return <div className='landing-data-edit-form-cont '>
            <div className="landing-data-content-container  text-light small">
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Edit float")}
                >
                    <Button 
                        intent={Intent.NONE}  
                        className={`p-1`} 
                        onClick={ onEditTitle }
                    > 
                        <img
                            src={ titleIcon }
                            height={ 12 }
                            className="svg-force-contrast landing-icon my-2"
                            style={{
                                height: 12,
                                opacity: 1,
                            }}
                            alt=""
                        /> 
                    </Button> 
                </Tooltip>
                
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Makeup")}
                >
                    <Button  
                        className={` p-1`}
                        intent={Intent.WARNING}
                        onClick={ onMakeup }
                    > 
                        <img
                            src={ makeupIcon }
                            height={ 12 }
                            className="svg-force-contrast landing-icon my-2"
                            style={{
                                height: 12,
                                opacity: 1,
                            }}
                            alt=""
                        />
                    </Button> 
                </Tooltip> 
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Delete")}
                >
                    <Button icon="trash" className="p-2 ml-1 " intent={Intent.DANGER} onClick={onDelete}  /> 
                
                </Tooltip>
            </div>
        </div>
}
export default FloatEditForm